<template>
  <div>
    <div class="createAn2-title intro-x">
      <div class="left">
        <!-- <div class="div1">选择所需套餐与功能</div> -->

        <div class="createAn2-header intro-x">
          <div v-for="(item, index) in pladList" :key="index" class="head-div">
            <span
              class="span1"
              :class="{ spanActive: isActive === index }"
              @click="setActiveItem(index)"
              >{{ item.title }}
            </span>
          </div>
        </div>
      </div>
      <div class="right intro-x">
        <span class="span1">
          <div>
            <font style="font-size: 18px; color: #333333">预估合计：</font>
            <font style="font-size: 18px; color: #ff4242"
              >{{ predictNum | formatMoney }}元</font
            >
          </div>
          <div>
            已选 <font style="color: #1890ff"> {{ labelNum }}</font> 个功能
          </div>
        </span>
        <span class="span2" @click="getMokuaiDataLabel">{{ laberText }}</span>
      </div>
    </div>

    <div class="carouselBlock">
      <template v-for="(item, index) in pladList">
        <div v-if="index === isActive" :key="index">
          <div class="car-Title intro-x">
            <i class="leftBorder"></i>
            <p class="car-name">套餐包含功能</p>
            <p class="car-content">套餐内包含功能为必选，不可去除</p>
          </div>

          <div class="basics-block intro-x">
            <div
              class="basice-item"
              v-for="(bas, cs) in item.baseList"
              :key="cs"
              @click="btnBasice"
            >
              <div class="item-head">
                <img :src="bas.icon" alt="" />
                <i class="el-icon-success"></i>
              </div>

              <div class="item-content">
                <p class="title">{{ bas.title }}</p>
                <div class="text">
                  终端支持：{{ bas.platform | fiPlatform }}
                </div>
              </div>
            </div>
          </div>

          <div class="car-Title">
            <i class="leftBorder"></i>
            <p class="car-name">选择终端</p>
            <p class="car-content">选择您想要的终端</p>
            <div class="carSlogan" v-if="item.notice">
              <span>优惠</span>{{ item.notice }}
            </div>
          </div>

          <div class="combo-box intro-x">
            <div
              :class="{
                comBorder: cob.status,
                favorable: item.favorable.length === 0 && cob.costMoney <= 0,
              }"
              class="combo-item"
              v-for="(cob, bo) in item.combo"
              :key="bo"
              @click="btnCombo(index, bo)"
            >
              <div
                class="favorable-item"
                v-show="item.favorable.length === 0 && cob.costMoney <= 0"
              >
                限时赠送
              </div>

              <img :src="cob.status ? cob.url2 : cob.url1" alt="" />
              <div class="combo-content">
                <p class="combo-title">{{ cob.title }}</p>
                <p class="combo-money">
                  <span class="combo-span1">
                    {{ item.favorable.length >= 1 ? cob.money : cob.costMoney }}
                  </span>
                  <span class="combo-span2">元/年</span>
                </p>
              </div>
              <i
                :class="cob.status ? 'el-icon-success' : 'combo-unselected'"
              ></i>
            </div>
          </div>

          <div class="car-Title" v-if="item.extList.length >= 1">
            <i class="leftBorder"></i>
            <p class="car-name">推荐加购功能</p>
            <p class="car-content">注：部分功能仅支持指定终端使用</p>
          </div>

          <div class="expand-box intro-x">
            <div
              class="expand-item"
              :class="{ expadLal: ext.label, 'expand-isClass': ext.isClass }"
              v-for="(ext, bo) in item.extList"
              :key="bo"
              @click="btnTerminal(index, bo)"
            >
              <div class="expand-head">
                <i
                  :class="
                    ext.isClass
                      ? 'el-icon-remove'
                      : ext.label
                      ? 'el-icon-success'
                      : 'expand-unselected'
                  "
                ></i>
              </div>
              <div class="expand-imgBox">
                <img :src="ext.icon" class="expand-img" alt="" />
                <p class="expand-span">{{ ext.title }}</p>
              </div>

              <div class="expand-platform">
                终端支持：{{ ext.platform | fiPlatform }}
              </div>

              <div class="expand-bottom">
                <p :class="ext.isClass ? 'expand-optional' : 'expand-money'">
                  <span class="expand-span1"> 套餐价 {{ ext.cost || 0 }} </span>
                  <span class="expand-span2">元/年</span>
                </p>
                <p class="mContent">原价{{ ext.money || 0 }}</p>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import request from "../utils/request";

export default {
  filters: {
    fiPlatform: function (arr) {
      let textArr = [];
      for (let item of arr) {
        if (item === "android") {
          textArr.push("安卓端");
          continue;
        }
        if (item === "ios") {
          textArr.push("ios端");
          continue;
        }

        if (item === "applet") {
          textArr.push("小程序端");
          continue;
        }
        if (item === "web") {
          textArr.push("web端");
          continue;
        }
      }
      return textArr.join("、");
    },
  },
  props: ["planData"],
  data() {
    return {
      isList: 1,
      imgs2: require("../assets/images/mokuai2.png"),
      imgs1: require("../assets/images/mokuai1.png"),
      predictNum: 0,
      laberText: "全选",
      isActive: 0,
      labelNum: 0,
      calcParam: null,
      favorable: [],
    };
  },

  computed: {
    pladList: function () {
      let list = [];
      let arr = [];
      for (let i = 0; i < this.planData.length; i++) {
        list = this.planData[i];

        if (list.laber) {
          /**
           *  查找、添加必选模块
           */
          list.baseList = [];
          let baseList = list.mod_base.split(",");

          for (let j in baseList) {
            for (let c in list.modules) {
              if (baseList[j] === list.modules[c].mod_id) {
                list.baseList.push(list.modules[c]);
              }
            }
          }

          /**
           *  查找、添加拓展模块
           */
          list.extList = [];
          let extList = list.mod_ext.split(",");
          for (let j in extList) {
            for (let c in list.modules) {
              if (extList[j] === list.modules[c].mod_id) {
                let money = 0;
                let cost = 0;
                let platform = list.modules[c].platform;
                for (let item of platform) {
                  if (item === "android") {
                    money = money + Number(list.modules[c].price_android);
                    cost = cost + Number(list.modules[c].cost_price_android);
                  }
                  if (item === "ios") {
                    money = money + Number(list.modules[c].price_ios);
                    cost = cost + Number(list.modules[c].cost_price_ios);
                  }
                  if (item === "web") {
                    money = money + Number(list.modules[c].price_web);
                    cost = cost + Number(list.modules[c].cost_price_web);
                  }
                  if (item === "applet") {
                    money = money + Number(list.modules[c].price_applet);
                    cost = cost + Number(list.modules[c].cost_price_applet);
                  }
                }
                list.modules[c].money = money;
                list.modules[c].cost = cost;
                list.modules[c].label = false;

                list.extList.push(list.modules[c]);
              }
            }
          }

          /**
           * 查找重组选择终端
           */
          list.combo = [];
          for (let item of list.platform) {
            list.combo.push({
              money: list[`price_${item}`],
              name: item,
              title: this.getTerminal(item),
              url1: require(`../assets/images/${item}1.png`),
              url2: require(`../assets/images/${item}2.png`),
              status: false,
              costMoney: list[`cost_price_${item}`],
              msg: list[`cost_price_${item}`] <= 0 ? "限时赠送" : false,
            });
          }

          list.favorable = list.combo.filter((item) => {
            return item.msg === false && item.status === false;
          });

          arr.push(list);
        }
      }

      return arr;
    },
  },

  mounted() {
    this.getCalc();
  },

  methods: {
    getTerminal: function (value) {
      if (value === "android") {
        return "安卓端";
      }
      if (value === "ios") {
        return "ios端";
      }
      if (value === "applet") {
        return "小程序端";
      }
      if (value === "web") {
        return "H5端";
      }
    },

    // 后端计算价格
    async getCalc() {
      let pladList = this.pladList;
      let plan = [];
      let labelNum = 0;

      let mergeArr = [];

      for (let i in pladList) {
        let platform = pladList[i].combo;
        let mergeData = {
          title: `${pladList[i].title}套餐内${pladList[i].baseList.length}个功能`,
          platform: await this.getPlatformContent(platform),
          formName: await this.getPlatformName(platform),
          period: "一年",
          money: await this.getPlatformMoney(platform),
        };
        if (mergeData.formName != "") {
          mergeArr.push(mergeData);
        }
      }

      for (let i in pladList) {
        let extList = pladList[i].extList;
        let platform = pladList[i].combo;

        let baseList = pladList[i].baseList;

        for (let j in extList) {
          let fromName = await this.getPlatformName2(
            platform,
            extList[j].platform
          );

          if (extList[j].label) {
            let mergeData = {
              title: extList[j].title,
              period: "一年",
              platform: extList[j].platform,
              formName: fromName,
              money:
                fromName.split("、").length === extList[j].platform.length
                  ? extList[j].cost
                  : extList[j].money,
            };
            mergeArr.push(mergeData);
          }
        }

        let param = {
          ext_modules: [],
          platform: [],
          id: pladList[i].plan_id,
        };

        for (let j in baseList) {
          param.ext_modules.push(baseList[j].mod_id);
          labelNum++;
        }

        for (let j in extList) {
          if (extList[j].label) {
            param.ext_modules.push(extList[j].mod_id);
            labelNum++;
          }
        }

        for (let j in platform) {
          if (platform[j].status) {
            param.platform.push(platform[j].name);
          }
        }

        if (param.platform.length >= 1) {
          plan.push(param);
        }
      }

      if (plan.length >= 1) {
        let param = {
          app_id: 1,
          plan: plan,
          pay_mode: 1,
          pay_way: 1,
          coupon: "",
        };

        request({
          url: "/api/plan/calc",
          method: "POST",
          data: param,
        })
          .then((res) => {
            this.predictNum = res.data.price;

            this.$emit('onRredictNum', { predictNum: res.data.price  , labelNum: labelNum})
          })
          .catch((err) => {
            this.$message.error("接口错误");
          });

        this.calcParam = param;
      } else {
        this.predictNum = 0;
      }
      this.mergeArr = mergeArr;

      this.labelNum = labelNum;
    },

    getMokuaiDataLabel: function () {
      let pladList = this.pladList;

      if (this.laberText === "全选") {
        for (let i in pladList) {
          let combo = pladList[i].combo;
          for (let j in combo) {
            combo[j].status = true;
          }
          let extList = pladList[i].extList;
          for (let j in extList) {
            extList[j].label = true;
            extList[j].isClass = false;
          }
        }

        this.laberText = "反选";
      } else {
        for (let i in pladList) {
          let combo = pladList[i].combo;
          for (let j in combo) {
            combo[j].status = false;
          }
          let extList = pladList[i].extList;
          for (let j in extList) {
            extList[j].label = false;
            extList[j].isClass = true;
          }
        }
        this.laberText = "全选";
      }

      this.$forceUpdate();
      this.getCalc();
    },
    getPlatformMoney: function (arr) {
      let money = 0;
      let num = 0;
      for (let item of arr) {
        if (item.status === true) {
          money = money + Number(item.money);
          num++;
          // if (num === arr.length) {
          //   money = item.price_credit;
          // }
        }
      }

      return Promise.resolve(money);
    },

    getPlatformContent: function (arr) {
      let data = [];
      for (let i in arr) {
        data.push(arr[i].name);
      }
      return data;
    },

    getPlatformName2: function (arr, arr2) {
      let textArr = [];
      for (let item of arr) {
        if (item.status === true && arr2.indexOf(item.name) != -1) {
          textArr.push(item.title);
        }
      }
      return Promise.resolve(textArr.join("、"));
    },

    getPlatformName: function (arr) {
      let textArr = [];
      for (let item of arr) {
        if (item.status === true) {
          textArr.push(item.title);
        }
      }
      return Promise.resolve(textArr.join("、"));
    },

    // 切换轮播图
    setActiveItem: function (index) {
      this.isActive = index;
      this.$refs.carousel.setActiveItem(index);
    },

    // btn 套餐包含功能
    btnBasice: function () {
      this.$message.info("套餐内包含功能为必选，不可去除");
    },

    // 内置功能模块选择按钮
    async btnCombo(i, k) {
      this.pladList[i].combo[k].status = !this.pladList[i].combo[k].status;

      this.pladList[i].favorable = this.pladList[i].combo.filter((item) => {
        return item.msg === false && item.status === false;
      });

      if (this.pladList[i].favorable.length === 0) {
        this.pladList[i].combo.forEach((item) => {
          if (!item.status) {
            item.status = true;
          }
        });
      }

      let extList = this.pladList[i].extList;
      if (this.pladList[i].combo[k].status) {
        let nameArr = this.pladList[i].combo.filter((item) => {
          return item.status;
        });
        if (nameArr.length === 4) {
          for (let item of extList) {
            if (
              item.platform.indexOf(nameArr[0].name) != -1 ||
              item.platform.indexOf(nameArr[1].name) != -1 ||
              item.platform.indexOf(nameArr[2].name) != -1 ||
              item.platform.indexOf(nameArr[3].name) != -1
            ) {
              item.isClass = false;
            } else {
              item.isClass = true;
            }
          }
        } else if (nameArr.length === 3) {
          for (let item of extList) {
            if (
              item.platform.indexOf(nameArr[0].name) != -1 ||
              item.platform.indexOf(nameArr[1].name) != -1 ||
              item.platform.indexOf(nameArr[2].name) != -1
            ) {
              item.isClass = false;
            } else {
              item.isClass = true;
            }
          }
        } else if (nameArr.length === 2) {
          for (let item of extList) {
            if (
              item.platform.indexOf(nameArr[0].name) != -1 ||
              item.platform.indexOf(nameArr[1].name) != -1
            ) {
              item.isClass = false;
            } else {
              item.isClass = true;
            }
          }
        } else if (nameArr.length === 1) {
          for (let item of extList) {
            if (item.platform.indexOf(nameArr[0].name) != -1) {
              item.isClass = false;
            } else {
              item.isClass = true;
            }
          }
        }
      } else {
        // 取消
        let nameArr = this.pladList[i].combo.filter((item) => {
          return item.status;
        });

        if (nameArr.length === 3) {
          for (let item of extList) {
            console.log(item);
            if (
              item.platform.indexOf(nameArr[0].name) != -1 ||
              item.platform.indexOf(nameArr[1].name) != -1 ||
              item.platform.indexOf(nameArr[2].name) != -1
            ) {
              item.isClass = false;
            } else {
              item.isClass = true;
              item.label = false;
            }
          }
        } else if (nameArr.length === 2) {
          for (let item of extList) {
            if (
              item.platform.indexOf(nameArr[0].name) != -1 ||
              item.platform.indexOf(nameArr[1].name) != -1
            ) {
              item.isClass = false;
            } else {
              item.isClass = true;
              item.label = false;
            }
          }
        } else if (nameArr.length === 1) {
          for (let item of extList) {
            if (item.platform.indexOf(nameArr[0].name) != -1) {
              item.isClass = false;
            } else {
              item.isClass = true;
              item.label = false;
            }
          }
        } else {
          // 最后一个
          for (let item of extList) {
            item.isClass = true;
            item.label = false;
          }
        }
      }
      // this.init();

      this.getCalc();
      this.$forceUpdate();
    },

    // 拓展应用
    btnTerminal: function (i, k) {
      let combo = this.pladList[i].combo.filter((item) => {
        return item.status === true;
      });

      if (combo.length === 0) {
        this.$message.warning("请先选择终端");
        return;
      }

      if (this.pladList[i].extList[k].isClass) {
        let textArr = [];
        let arr = this.pladList[i].extList[k].platform;
        for (let item of arr) {
          if (item === "android") {
            textArr.push("安卓端");
            continue;
          }
          if (item === "ios") {
            textArr.push("ios端");
            continue;
          }
          if (item === "applet") {
            textArr.push("小程序端");
            continue;
          }
          if (item === "web") {
            textArr.push("web端");
            continue;
          }
        }

        this.$message.warning(`该功能仅支持${textArr.join("、")}`);
        return;
      }

      this.pladList[i].extList[k].label = !this.pladList[i].extList[k].label;

      this.getCalc();
      this.$forceUpdate();
    },
  },
};
</script>

<style lang="scss" scoped>
.carouselBlock {
  width: 77.6%;
  //height: 730px;
  box-sizing: border-box;
  margin: auto;
}

.ActiveIiem {
  background: #1890ff !important;
  .rightTitle {
    color: #fff !important;
  }
  .rightContent {
    color: #74bcfe !important;
  }

  .yuanMoney {
    color: #74bcfe !important;
  }
  .taoMoney {
    color: #fff !important;
  }
}

// ~~~

.createAn2-header {
  width: 100%;
  text-align: center;
  padding: 30px 0;
  font-size: 18px;
  color: #333333;
  span {
    display: inline-block;
    padding-bottom: 4px;
    position: relative;
    cursor: pointer;
  }
  .span1 {
    margin-right: 30px;
  }
  .spanActive {
    color: #1890fe;
  }

  .spanActive::after {
    content: "";
    position: absolute;
    height: 4px;
    background: #1890ff;
    border-radius: 2px;
    bottom: 0;
    width: 90%;
    left: 5%;
  }
}

.createAn2-title {
  width: 77.6%;

  overflow: hidden;
  margin: auto;
  .left {
    float: left;
    .div1 {
      color: #333333;
      font-size: 16px;
    }
    .div2 {
      color: #999999;
      font-size: 12px;
    }
  }
  .right {
    float: right;
    padding: 30px 0;
    .span1 {
      font-size: 14px;
      color: #333333;
      float: left;
      text-align: right;
    }
    .span2 {
      float: right;
      margin-left: 10px;
      background: #1890ff;
      font-size: 14px;
      color: #fff;
      width: 68px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      margin-top: 10px;
      border-radius: 15px;
    }

    .span2:active {
      background: #2d97fa;
    }
  }
}

.createAn2-html {
  width: calc(77.6% + 12px);
  margin: 40px auto 0;
}

.createAn2-content {
  width: calc(100% + 12px);
  overflow: hidden;
  margin: auto;

  .item-box {
    width: 194px;
    height: 98px;
    box-sizing: border-box;
    background: #fcfcfd;
    border: 1px solid #f4f4f7;
    opacity: 1;
    border-radius: 16px;
    float: left;
    margin: 0 12px 12px 0;
    padding: 10px 12px;
    cursor: pointer;
  }

  .mokuai-img {
    width: 34px;
    height: 34px;
    float: left;
    margin-right: 4px;
  }
  .mokuai-right {
    float: left;
    width: 77%;

    .rightTitle {
      color: #333333;
      font-size: 14px;
      height: 18px;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .rightContent {
      color: #999999;
      font-size: 12px;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .div-top {
    overflow: hidden;
    margin-bottom: 4px;
  }

  .yuanMoney {
    font-size: 12px;
    color: #999999;
    text-decoration: line-through;
  }
  .taoMoney {
    color: #1890ff;
    font-size: 12px;
  }

  .float-yuan {
    width: 20px;
    height: 20px;
    background: #ffffff;
    border-radius: 50%;
    float: right;
    margin-top: 15px;
    text-align: center;
    line-height: 20px;
    color: #1890ff;
    font-weight: bold;
  }
}

.head-div {
  display: inline-block;
}

.car-Title {
  height: 37px;
  padding-left: 15px;
  position: relative;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 20px;

  .carSlogan {
    position: absolute;
    height: 20px;
    top: 0px;
    bottom: 0px;
    margin: auto;
    left: 130px;
    color: #ff4049;
    font-size: 13px;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;

    span {
      background: #ff2640;
      color: #fff;
      margin-right: 5px;
      font-size: 10px;
      border-radius: 4px;
      padding: 2px 4px;
      vertical-align: 1px;
    }
  }
}

.leftBorder {
  position: absolute;
  left: 0;
  top: 0;
  height: 37px;

  width: 5px;
  background: #1890ff;
}

.car-name {
  color: #333333;
  font-size: 18px;
  line-height: 18px;
}

.car-content {
  color: #999999;
  font-size: 12px;
  padding-top: 8px;
  line-height: 12px;
}

.basics-block {
  margin-bottom: 30px;
  width: calc(100% + 12px);
}

.basice-item {
  width: 194px;
  height: 138px;
  background: #fcfcfd;
  border: 1px solid #1890ff;
  opacity: 1;
  border-radius: 16px;
  padding: 12px;
  box-sizing: border-box;
  display: inline-block;
  margin: 0 12px 12px 0;
  vertical-align: top;
  cursor: pointer;
}

.item-head > img {
  display: inline-block;
  vertical-align: middle;
  width: 50px;
}

.item-head > .el-icon-success {
  float: right;
  color: #1890fe;
  font-size: 20px;
}

.item-content {
  margin-top: 8px;
  .title {
    color: #333333;
    font-size: 14px;
    line-height: 16px;
  }
  .text {
    color: #999999;
    font-size: 12px;
    display: inline-block;
    line-height: 16px;
    margin-top: 4px;
  }
}

.combo-box {
  width: 100%;
  display: flex;
  margin-bottom: 30px;
}

.combo-item {
  width: 242px;
  height: 74px;
  background: #fcfcfd;
  border: 1px solid #f4f4f7;
  opacity: 1;
  border-radius: 16px;
  margin-right: 17px;
  padding: 14px 12px;
  box-sizing: border-box;
  cursor: pointer;
  position: relative;
  white-space: nowrap;
  .favorable-item {
    position: absolute;
    right: -15px;
    top: -12px;
    width: 66px;
    height: 22px;
    font-size: 11px;
    color: #fff;
    background: #ff5353;
    text-align: center;
    line-height: 22px;
    border-radius: 10px 2px 10px 2px;
  }

  img {
    width: 34px;
    vertical-align: top;
    display: inline-block;
    margin: 6px 10px 0 0;
  }
  .combo-content {
    display: inline-block;
    height: 100%;

    .combo-title {
      color: #333333;
      font-size: 14px;
    }
    .combo-money {
      color: #1890ff;
      margin-top: 4px;
      .combo-span1 {
        font-size: 18px;
        line-height: 18px;
      }
      .combo-span2 {
        font-size: 12px;
        line-height: 12px;
      }
    }
  }

  .combo-unselected {
    float: right;
    width: 20px;
    height: 20px;
    background: #ffffff;
    border: 1px solid #e6e8ee;
    border-radius: 50%;
    opacity: 1;
    position: absolute;
    right: 12px;
    margin-top: 12px;
  }

  .el-icon-success {
    float: right;
    font-size: 20px;
    color: #1890ff;
    margin-top: 12px;
    position: absolute;
    right: 12px;
  }
}

.comBorder {
  border: 1px solid #1890ff;
}

.favorable {
  cursor: not-allowed;
}

.expand-item {
  width: 194px;
  height: 259px;
  background: #fcfcfd;
  border: 1px solid #f4f4f7;
  opacity: 1;
  border-radius: 16px;
  display: inline-block;
  margin: 0 12px 12px 0;
  vertical-align: middle;
  padding: 0 12px;
  box-sizing: border-box;
  cursor: pointer;

  .expand-head {
    width: 100%;
    position: relative;
    height: 42px;
    .expand-unselected {
      float: right;
      width: 20px;
      height: 20px;
      background: #ffffff;
      border: 1px solid #e6e8ee;
      border-radius: 50%;
      margin-top: 12px;
    }

    .el-icon-success {
      color: #1890ff;
      font-size: 20px;
      float: right;
      margin-top: 12px;
    }

    .el-icon-remove {
      color: #999999;
      font-size: 20px;
      float: right;
      margin-top: 12px;
    }
  }

  .expand-imgBox {
    width: 100%;
    text-align: center;
    padding-bottom: 10px;
    border-bottom: 1px solid #f4f4f7;
    height: 85px;
    box-sizing: border-box;
    .expand-img {
      width: 50px;
      display: inline-block;
      vertical-align: middle;
    }
    .expand-span {
      color: #333333;
      font-size: 14px;
      line-height: 14px;
      margin-top: 10px;
    }
  }

  .expand-platform {
    color: #999999;
    font-size: 12px;
    padding: 16px 0px;
    text-align: center;
    border-bottom: 1px solid #f4f4f7;
    height: 67px;
    box-sizing: border-box;
  }
  .expand-money {
    color: #1890ff;
    margin-top: 4px;
    .expand-span1 {
      font-size: 14px;
      line-height: 14px;
    }
    .expand-span2 {
      font-size: 12px;
      line-height: 12px;
    }
  }

  .expand-optional {
    color: #999999;
    margin-top: 4px;
    .expand-span1 {
      font-size: 14px;
      line-height: 14px;
    }
    .expand-span2 {
      font-size: 12px;
      line-height: 12px;
    }
  }
}

.mContent {
  color: #dddddd;
  font-size: 12px;
  text-decoration: line-through;
}

.expand-bottom {
  text-align: center;
  height: 60px;
  box-sizing: border-box;
  padding-top: 10px;
}

.expadLal {
  border: 1px solid #1890ff;
}

.expand-isClass {
  cursor: not-allowed;
}

@media screen and (max-width: 1060px) {
  .combo-box {
    display: block;
  }
  .combo-item {
    display: inline-block;
    margin-bottom: 30px;
    width: calc(50% - 20px);
  }
}

@media screen and (max-width: 540px) {
  .favorable {
    width: 90%;
  }
}

@media screen and (max-width: 600px) {
  .combo-item {
    width: 95%;
  }

  .basice-item {
    width: 95%;
  }

  .createAn2-content {
    width: 100% !important;
  }
  .createAn2-content .item-box {
    width: 100% !important;
  }
}
</style>
